function login() {
  $('.acf-input input').focusin(function() {
    $(this).closest('.acf-field').addClass('focus');
  });

  $('.acf-input input').focusout(function() {
    if ($(this).val() == '') {
      $(this).closest('.acf-field').removeClass('focus');
    }
  });

  $('.acf-input input').each(function() {
    if ($(this).val() != '') {
      $(this).closest('.acf-field').addClass('focus');
    }
  });

  // Show/hide password fields.
  if (document.querySelector('input#password')) {
    const fieldWrapper = document.querySelector('.password-input');
    fieldWrapper.innerHTML += '<i class="fa fa-eye password-show-hide"></i>';

    const btn = document.querySelector('.password-input .password-show-hide');
    btn.addEventListener('click', function () {
      if (document.querySelector('input#password').type === 'password') {
        document.querySelector('input#password').type = 'text';
      }
      else {
        document.querySelector('input#password').type = 'password';
      }

      btn.classList.toggle('fa-eye');
      btn.classList.toggle('fa-eye-slash');
    });
  }
}

export { login };
